
<div>
    <div *ngFor="let item of customProductElament; let i=index" fxLayout="column" fxLayoutGap="10px">
      <b style="padding-top: 10px;">{{item.value}}</b>

      <div fxLayout="column" fxLayoutGap="10px" *ngFor="let itemList of item.productCustomizationList; let j=index">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">

          <mat-checkbox   [checked]= "selection.indexOf(itemList.entityId) >= 0" 
           (change)="updateCheckedOptions($event,item.value,i,j,itemList.entityId,itemList.value,item.type,item.valueId)">
            {{itemList.key}}</mat-checkbox>
          <b>{{itemList.value}}</b>
        </div>
      </div>
    </div>

  </div>
